/* eslint-disable default-param-last */
import axios from 'axios';
import apiBaseUrl from '../../config/apiBaseUrl';
import { processApiResponse } from '../helper/processApiResponse';
export const initAPI = {
    Init(params, setApiProcessingPool, setApiDonePool, config = {}) {
        const apiRoute = `${apiBaseUrl}/api/careClientVisitor/init`;
        return processApiResponse(axios.post(apiRoute, params, config), apiRoute, setApiProcessingPool, setApiDonePool);
    },
};
